import { loadBlossomServers } from '@nostr/gadgets/lists'
import { getHashFromURL } from '@nostr/tools/nipb0'

const resolved = new Map<string, string>()

export async function tryNextUrl(
  originalUrl: string,
  pubkey: string,
  tried: Set<string>
): Promise<string | null> {
  const cached = resolved.get(originalUrl)
  if (cached) return cached

  let hash: string | null
  let ext: RegExpMatchArray | null
  try {
    const oldImageUrl = new URL(originalUrl)
    hash = getHashFromURL(oldImageUrl)
    ext = oldImageUrl.pathname.match(/\.\w+$/i)
  } catch {
    return null
  }
  if (!hash || !ext) return null

  const blossomServerList = await loadBlossomServers(pubkey)
  const nextServer = blossomServerList.items
    .map((server) => {
      try {
        return new URL(server)
      } catch (error) {
        console.error('Invalid Blossom server URL:', server, error)
        return undefined
      }
    })
    .filter((url): url is URL => !!url && !tried.has(url.hostname))[0]

  if (!nextServer) return null

  tried.add(nextServer.hostname)
  nextServer.pathname = '/' + hash + ext
  return nextServer.toString()
}

export function markAsSuccess(originalUrl: string, successUrl: string) {
  resolved.set(originalUrl, successUrl)
}
